// Curated, user-facing changelog for the "What's new" modal. Only significant
// UX/UI features and notable bug fixes belong here — not every commit.
export const CHANGELOG = [
  {
    date: '2026-11-03',
    items: [
      'Timesheet reminders respect your Outlook calendar: if you connected Outlook in Settings, a day you are out of office for at least half of your working hours as set in Outlook (a vacation, a half day off) is not asked for, even with nothing logged. Out of office outside your working hours does not count. Admins switch it on or off on the Reminders page',
      'Public holidays of your country are greyed out in My calendar like a weekend, with the holiday’s name under the date, and named next to the day in the Timesheet. A team manager or admin opening a member in Team sees that member’s holidays, by the member’s country (Team → Edit member), not their own.',
      'Pick your own country in Settings → Public holidays, so timesheet reminders skip its public holidays. Until now only an admin could set it, in Team → Edit member',
      'A project manager can add another project manager to a project they run: Project Info → Roles → Edit, then pick the person under Delivery. Anyone in the company is on offer there now, and in the other role pickers too, not only people who logged time on your projects. Removing a project manager stays with an admin',
    ],
  },
  {
    date: '2026-11-02',
    items: [
      'Absence is paid or unpaid. Paid absence (vacation, sick leave, public holidays… that you are paid for) counts toward your total hours and MD again, as it did before 21 October; unpaid absence is shown on its own and never counted. Every absence logged so far stays paid, except HPP - Unpaid Leave. Admins choose paid or unpaid per absence project in Project Info → Logging guidance',
      'Timesheet, My report and Reports show the same five boxes: Total (client work + internal work + paid absence, with MD), Client work, Internal work, Paid absence and Unpaid absence, with a bar that draws how the total is made. Client work share is taken of work only, never of absence',
      'The Work type filter in Reports, My report and Team now ticks any of the four work types, each with its hours in the period, so you can see what an unticked type leaves out. Reports’ By person table and the Excel export have a column for each; By project and By client list paid and unpaid absence in sections of their own',
    ],
  },
  {
    date: '2026-10-31',
    items: [
      'Timesheet reminders know the public holidays of about 200 countries, not just Czechia and Slovakia: pick a member’s country in Team → Edit member and its holidays are never asked for. The Reminders page lists exceptions for the countries your people are on',
    ],
  },
  {
    date: '2026-10-29',
    items: [
      'Timesheet reminders: when an admin turns them on (Reminders in the sidebar), a working day with no entry in a past week gets you one e-mail on Monday listing the days, and a second one on Thursday if last week is still empty - that one also goes as a summary to your team manager. Days on an absence project, weekends and the public holidays of your country (set per member) are never asked for. Admins can keep it in report-only mode, exempt a member, pick who gets the escalations nobody else can, and add exceptions to the Czech and Slovak public-holiday calendars, which are otherwise computed automatically',
    ],
  },
  {
    date: '2026-10-22',
    items: [
      'The Clients, Projects, Teams and People filters on Team, Reports, My report and the project and client tabs that use them take less room: only their search fields show until you move the mouse over them (or Tab into them), so the table below is in view. The number next to each title still tells you how many are selected',
    ],
  },
  {
    date: '2026-10-21',
    items: [
      'Absence is no longer counted as worked time: vacation, sick leave, doctor, family care, personal or unpaid leave and public holidays stay out of total hours and MD in Reports, Team, client and project figures, the Excel export and Claude, and are shown on their own as Absence instead. Client work hours stay the same. This also lowers past totals of anyone who logged absence before, including vacation imported from Clockify',
      'Absence looks different in the calendar: grey hatching with a solid grey edge and a crossed-out calendar icon instead of the project colour',
    ],
  },
  {
    date: '2026-10-20',
    items: [
      'Only absence can be logged ahead now: vacation, sick leave, doctor, family care, personal or unpaid leave and public holidays go on any future day, while work can be logged up to the end of today - Log time offers just the absence projects for a future date, and the calendar says so when work is dropped or moved onto a future day. Admins mark which projects count as absence in Project Info - Logging guidance',
    ],
  },
  {
    date: '2026-10-14',
    items: [
      'The browser tab now shows the Born Digital mark: in the brand colours when no timer runs, and with its petals in cyan while a timer runs, amber while it is paused and red once it is stopped and waiting to be saved',
    ],
  },
  {
    date: '2026-10-12',
    items: [
      'A project can now tell you how to log time on it: pick one of the HPP absence projects (Sickness, Family Care, Medical Appointment, Personal Leave, Unpaid Leave) in Log time and a short note explains when to use it and how many hours to log, with a link to the full guide on the wiki. Project managers and admins write the note in Project Info - Logging guidance',
    ],
  },
  {
    date: '2026-10-10',
    items: [
      'A forgotten timer now also e-mails you: once when it has been running for 8 hours without a break, and again if Time Tracker pauses it after 12 hours - with the project, when it started and a button straight back to Time Tracker. Nothing is ever saved for you',
      'Filters now stay put: the search, status, client, team member and tier you set on Projects, Clients or Team, the selections and work type in Reports and My report, table sorting and the week or month you were looking at are all still there after you open a detail, go back with All projects or the browser Back button, visit another page or refresh. The tab of an open project or client is part of its link, so Back, refresh and a shared link come back to it, while another project or client opens on its Info tab. Reset filters appears whenever something is filtered and puts it back in one click; signing out starts you fresh',
      'The report period is one field now: pick a preset (This week … All time), click two days in the two-month calendar, or type the dates - the field shows which preset is active or that the range is Custom',
      'Dates, drop-downs, checkboxes, scrollbars and tooltips across the app now look like the rest of Time Tracker instead of the browser defaults - dates read and type as DD.MM.YYYY with a Monday-first calendar, and long drop-downs such as clients or team members have a search box',
    ],
  },
  {
    date: '2026-10-09',
    items: [
      'The timer now lives on the server: a refresh, a closed tab, logging out or opening Time Tracker in another tab or on another device keeps it running - every tab shows the same timer and a pause or stop in one shows up in the others',
      'A forgotten timer is caught: after 8 hours of running it asks whether you are still working, after 12 hours it pauses itself (nothing is saved), and the save dialog lets you set the real end time',
      'Claude can now see, start, pause, resume and stop your timer - stopping saves it as time entries, one per day, exactly like the web',
    ],
  },
  {
    date: '2026-10-08',
    items: [
      "Claude can now close, pause or reopen a project - the same Status as in the project's edit dialog, so a completed or paused project leaves the list people log time against. It asks you to confirm first, Trace shows the old and new status, and the lifecycle phase stays as it was",
      'Project History has a new Import entry type for what was loaded automatically, for example from HubSpot or Excel - it has its own marker and an Automatic import label, so it is never mistaken for a hand-written note. Only Claude (through MCP) writes these; you can still edit one, and it stays an Import',
      "An admin can now have Claude set a project's delivery managers - active people only, recorded in Trace from whom to whom - and Claude can include a direct link that opens the project or client in Time Tracker",
    ],
  },
  {
    date: '2026-10-07',
    items: [
      "Claude (or another MCP client) can now update a project's name, code, group, HubSpot link, start and end date, budget and billable flag, and a client's group - the same fields you can edit as the project's or client's manager. It asks you to confirm a change to the name, code, budget or billable flag first, and Trace shows each field's old and new value",
    ],
  },
  {
    date: '2026-10-03',
    items: [
      "Clients have a new Transaction data tab: the client's voice calls month by month - calls, duration and tarification minutes, inbound and outbound - with a per-organization, language or project breakdown you can expand. Admins link a client's platform organizations in Client Info and recompute a month for that client; the new Billing page recomputes every client and lists organizations with calls that belong to no client",
      'Billing names every organization that had calls but belongs to no client and preselects the client with the same name - check it and click Link, or create a new client for it in one step with New client. The list covers every computed month and shows which months each organization had calls in; in Client Info the platform name shows as you type an organization id',
      'Billing shows calls and duration of the last 12 months across all clients as two charts; hover a month for its exact value',
    ],
  },
  {
    date: '2026-09-30',
    items: [
      'Projects now have a Tier (1, 2 or 3): set it in Project Info - Basics or when creating a project, then sort or filter the Projects list by it',
    ],
  },
  {
    date: '2026-09-17',
    items: [
      "Claude (or another MCP client) can now connect to Time Tracker on your behalf — log time, check reports, and read or update project and client intelligence for you. Connect it from Settings, where you can also see and revoke any AI client you've connected",
      "Project Info's Roles and Lifecycle phase now update immediately after you save, and pick up changes made anywhere else too — previously they only refreshed the next time you opened the project",
    ],
  },
  {
    date: '2026-09-03',
    items: [
      'Teams can now have team managers: open Team - Manage teams, click Edit on a team and tick one or more people (a person can manage several teams)',
      'A team manager gets the Team tab with the people of the teams they manage - their hours, MDs, project breakdown and week calendar - without becoming an admin',
      'Team managers see people only, not money: adding or editing members, teams, clients, projects and budgets stays with admins',
    ],
  },
  {
    date: '2026-08-03',
    items: [
      'The date range and work type you pick now travel with you across screens — open a team member, client, or project detail and it shows the same period you were just looking at, instead of resetting to this month',
      "The calendar on a team member's detail now opens on the week matching the selected period (pick Last week and you'll see last week), and the arrows still step week by week from there",
      'The address bar now reflects where you are: refreshing keeps you on the exact page — open detail and period included — the browser Back button walks your screens, and you can copy the link to share a specific person and period with a colleague',
    ],
  },
  {
    date: '2026-07-28',
    items: [
      'The "Connect Outlook" hint on My calendar can now be closed with an X — once dismissed it stays gone for good, on any device, even if you never connect Outlook',
    ],
  },
  {
    date: '2026-07-22',
    items: [
      'Projects now have a HubSpot field in project settings — paste the link to the project\'s HubSpot record and it shows as an "Open in HubSpot" link on the project card',
      'You can leave off the https:// when pasting; only hubspot.com links are accepted so a mistyped link is caught before it saves',
      'Timesheet now has a Day period alongside Week and Month, so you can focus on a single day; the arrows step one day at a time, Week is the default, and your chosen period is remembered next time',
      'Refreshing the page now keeps you on the page you were on instead of always jumping back to My calendar',
    ],
  },
  {
    date: '2026-07-20',
    items: [
      'Projects can now be marked as Support projects in project settings, creating a reliable distinction between ongoing support work and new delivery projects',
      'Existing projects with "support" in their name are classified as Support projects automatically during the database upgrade',
      'Reports now include interactive donut charts for hours by client, project, team, or person, with smaller categories grouped into a detailed Other segment',
      'Report tables now group clients into External and Internal sections and projects into New and Support sections; sections can be collapsed and entity rows open their detail pages',
      'Selected report filters stay visible at the top of long lists and related filter options narrow each other to make active selections easier to find',
      'Clients, Projects, and Team now share date-range and work-type filters, period-aware KPI cards, Hours and MD columns, and default sorting by hours in the selected period',
      'Client, project, and team-member detail pages can now be filtered by date range and work type; team-member details also show a project-hours donut chart for the selected period',
    ],
  },
  {
    date: '2026-07-14',
    items: [
      'Connect your Outlook calendar from Settings to see your planned meetings as a read-only overlay on My calendar, alongside your tracked time — visible only to you and never stored',
      'Turn an Outlook event into a time entry with its exact time range, or start a timer for it right away, straight from the calendar',
      "An eye icon next to the calendar's zoom controls hides or shows the Outlook overlay independently of your own entries",
      'A small sidebar indicator shows when Outlook was last synced, with a one-click refresh',
      'Starting a timer no longer requires picking a project first — pick one when you stop and save',
    ],
  },
  {
    date: '2026-07-08',
    items: [
      "Timesheet can now be grouped by day: each day is its own section (newest first) showing the weekday, a Today marker, and the day's total hours and man-days",
      'Each day header has a + to log time on that day, pre-filling the entry date for you',
      'A Grouped/Flat toggle switches back to the original sortable list and remembers your choice',
      'A running timer now shows in the browser tab: the title counts up and the favicon turns into a colored play/pause/stop badge, so you can see it from another tab',
      'A running timer now previews on the calendar as a live gray "to-be" block on today\'s column, growing from the start time down to the current-time line so your week already shows what you\'re about to log',
      'Pausing and resuming shows each work stretch as its own block — an exact preview of the entries that will be saved',
    ],
  },
  {
    date: '2026-07-01',
    items: [
      'Added this "What\'s new" changelog to the sidebar',
      'The timer keeps running when you navigate to other pages instead of blocking you or discarding your progress',
      'The running/paused timer can now be edited in place: switch project, change the description, or adjust the start time',
      'Project managers can now create new projects for clients they manage, not just admins',
      'My Report, Reports, and Timesheet tables are now sortable by column',
      'Timesheet merges date and time into one sortable column and defaults to showing the newest entries first',
      'Added a Week/Month toggle to Timesheet navigation',
      'Creating or deleting a calendar time entry now shows clear "Saving..." / "Deleting..." feedback',
    ],
  },
  {
    date: '2026-06-30',
    items: [
      "Sidebar now shows the app version that's currently running",
      'Sticky calendar day headers stay on top when hovering entries underneath',
      'Modals can now be closed by pressing Escape',
    ],
  },
  {
    date: '2026-06-29',
    items: [
      'Reworked calendar interactions: click an empty slot to create an entry, drag to move or resize it, right-click to duplicate, with a confirmation before deleting',
      'Added a time-slot zoom control and per-day hour totals, plus a live line marking the current time',
      'Switched the entry From/To fields to 24-hour digit entry with an editable duration, snapped to a 5-minute grid',
      'Entries now require a project and a valid end time after the start',
    ],
  },
  {
    date: '2026-06-25',
    items: [
      'Fixed report data scope for admins and added an "all time" date preset',
    ],
  },
  {
    date: '2026-06-24',
    items: ['App go-live'],
  },
];
